import React from 'react';
import Link from 'next/link';
import { getProductDetailUrl } from '@/url/product';
import {
  isExistInComparisonList,
  prepareProductDetailSlug,
} from '@/utils/object';
import { useSelector } from 'react-redux';
import { ADD_TO_COMPARE } from '@/constants';
import { cardViewTypes, screenTypes } from '@/constants/types';
import { cn } from '@/utils/cn';
import { usePathname } from 'next/navigation';
import CompareButton from '../../Button/CompareButton';
import IncreaseDecreaseButton from '../../Button/IncreaseDecreaseButton';
import AddToCartActionWithLoadingButton from '../../Button/AddToCartActionWithLoadingButton';
import SeeDetailsButton from '../../Button/SeeDetails';

function ProductCardCTA({
  isSeeDetails = false,
  isStockLimited = false,
  productData,
  onDetailsView,
  productInCart,
  viewOption,
  listView,
  screenWidth,
}) {
  // get path from url
  const pathname = usePathname();
  const isProductListingPage =
    pathname.startsWith('/category') || pathname.startsWith('/brand');

  // store
  const { comparisonMode, comparingProducts } = useSelector(
    (state) => state.productComparison,
  );

  const getComparisonButtonLabel = (currentId) => {
    if (!isExistInComparisonList(comparingProducts, currentId)) {
      if (screenWidth >= screenTypes.large) {
        return ADD_TO_COMPARE;
      }
      return 'Compare';
    }
    return 'Added to Compare!';
  };

  // comparison mode on only for normal product not variant product and only on PLP page
  if (comparisonMode && !isSeeDetails && isProductListingPage) {
    return (
      <CompareButton
        hideIcon={!!isExistInComparisonList(comparingProducts, productData.id)}
        label={getComparisonButtonLabel(productData.id)}
        className={cn('bg-transparent', {
          'cursor-not-allowed border-none rounded-0 lg:w-full px-0 hover:bg-transparent':
            isExistInComparisonList(comparingProducts, productData.id),
        })}
        productData={productData}
        categoryData={
          productData?.parent_category?.slug
            ? productData?.parent_category
            : productData?.category
        }
      />
    );
  }

  // // out of stock
  // if (productData?.stockQtty === 0) {
  //   return <Button type="out-of-stock" />;
  // }

  // with variants product or stock limited
  if (isSeeDetails || isStockLimited) {
    return (
      <Link
        prefetch={false}
        aria-label="Go to product details"
        href={getProductDetailUrl(prepareProductDetailSlug(productData))}
      >
        <SeeDetailsButton onClick={onDetailsView} />
      </Link>
    );
  }

  if (productInCart) {
    return (
      <div className={cn('w-[124px] lg:w-[200px]')}>
        <div
          className={cn('flex items-center gap-[6px] w-full', {
            'order-2 xl:justify-end': listView,
            'justify-center': viewOption === cardViewTypes.grid,
          })}
        >
          <IncreaseDecreaseButton currentProduct={productData} />
        </div>
      </div>
    );
  }

  return <AddToCartActionWithLoadingButton currentProduct={productData} />;
}

export default ProductCardCTA;
